<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" [jhiTranslate]="type === 'create' ? 'MODAL_ADD_OR_UPDATE_INSURANCE_ITEM.TITLE.CREATE' : 'MODAL_ADD_OR_UPDATE_INSURANCE_ITEM.TITLE.UPDATE'">
      Add insurance item
    </h4>
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
  </div>
  <form>
    <div class="modal-body">
      <div class="row" *ngIf="controls">
        <div class="col-12"><span class="font-weight-bold" jhiTranslate="MODAL_ADD_OR_UPDATE_INSURANCE_ITEM.SUBTITLE"></span></div>
        <div class="col-12">
          <jhi-bary-input-text [control]="controls.itemsNature" [label]="'LABEL.ITEMS_NATURE' | translate"></jhi-bary-input-text>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number [control]="controls.maxValue" [max]="500000" [step]="1000" [label]="'LABEL.INSURANCE_MAX_VALUE_EURO' | translate"></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number [control]="controls.basePricing" [label]="'LABEL.INSURANCE_BASE_PRICE_EURO' | translate"></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number
            [control]="controls.insuranceRate"
            [max]="1"
            [min]="0"
            [step]="0.1"
            [label]="'LABEL.INSURANCE_RATE_PERCENT' | translate"
            keyTranslateMinError="ERROR.MIN_VAL"
            keyTranslateMaxError="ERROR.MAX_VAL"
          ></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number
            [control]="controls.pricingRate"
            [max]="1"
            [min]="0"
            [step]="0.1"
            [label]="'LABEL.INSURANCE_PRICING_RATE_PERCENT' | translate"
            keyTranslateMinError="ERROR.MIN_VAL"
            keyTranslateMaxError="ERROR.MAX_VAL"
          ></jhi-bary-input-number>
        </div>
      </div>
    </div>
    <div class="modal-footer flex-nowrap justify-content-end align-items-center">
      <jhi-bary-button [outline]="true" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ first: true })" class="mr-3" color="primary"></jhi-bary-button>
      <jhi-bary-button [label]="'BTN.CONFIRM' | translate" [disabled]="modalForm.status != 'VALID'" (clickEvent)="handleSubmit()" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
